import "@styles/base/pages/page-misc.scss";

import { Button } from "reactstrap";
import ImageWrapper from "@components/ui-components/image-wrapper";
import { Link } from "react-router-dom";
import { getHomeRouteForLoggedInUser } from "@helpers/utils";
import themeConfig from "@configs/theme-config";
import { useTranslation } from "react-i18next";

const Error = () => {

    document.title = "404 - Not Found";
    const { app:{ logo } } = themeConfig;
    const { t } = useTranslation();

    return (
        <div className="misc-wrapper">
            <span className="brand-logo">
                <ImageWrapper
                    src={logo}
                    id="brand-logo"
                    alt="logo"/>
            </span>
            <div className="misc-inner p-2 p-sm-3">
                <div className="w-100 text-center">
                    <ImageWrapper
                        width={300}
                        id="not-found"
                        height={300}
                        src={"common/not-found.png"}/>
                    <p className="my-2">
                        {t("Make sure the address is correct and that the page hasn't moved. If you think this is a mistake,contact us.")}
                    </p>
                    <Button
                        tag={Link}
                        to={getHomeRouteForLoggedInUser("/")}
                        color="primary"
                        className="btn-sm-block mb-1">
                        {t("Back to home")}
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default Error;
